import { Link } from 'react-router-dom';
import React from 'react';

const Footer = () => {
  return (
    <div
      className="section footer-section footer-section-03 footer-section-image"
      style={{ backgroundImage: "url(/images/bg/footer-bg.jpg)" }}
    >
      <div className="container">
        {/* <!-- Footer Widget Wrap Start --> */}
        <div className="footer-widget-wrap">
          <div className="row">
            <div className="col-lg-3 col-sm-6">
              {/* <!-- Footer Widget Start --> */}
              <div className="footer-widget-about">
                <Link className="footer-logo" to="/">
                  <img src="/images/logo.png" alt="Logo" />
                </Link>
                <p>
                  Drive innovation with elite remote tech teams
                </p>
                <div className="footer-social">
                  <ul className="social">
                    <li>
                      <Link href="#">
                        <i className="fab fa-facebook-f"></i>
                      </Link>
                    </li>
                    <li>
                      <Link href="#">
                        <i className="fab fa-twitter"></i>
                      </Link>
                    </li>
                    <li>
                      <Link href="#">
                        <i className="fab fa-linkedin-in"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              {/* <!-- Footer Widget End --> */}
            </div>
            <div className="col-lg-3 col-sm-6">
              {/* <!-- Footer Widget Start --> */}
              <div className="footer-widget">
                <h4 className="footer-widget-title">Useful Links</h4>

                <div className="widget-link">
                  <ul className="link">
                    <li>
                      <Link href="#">Terms & Conditions</Link>
                    </li>
                    <li>
                      <Link href="#">About Company</Link>
                    </li>

                    <li>
                      <Link href="#">Policy</Link>
                    </li>
                  </ul>
                </div>
              </div>
              {/* <!-- Footer Widget End --> */}
            </div>
            <div className="col-lg-3 col-sm-6">
              {/* <!-- Footer Widget Start --> */}
              <div className="footer-widget">
                <h4 className="footer-widget-title">Our Services</h4>

                <div className="widget-link">
                  <ul className="link">
                    <li>
                      <Link href="#">Data Security</Link>
                    </li>
                    <li>
                      <Link href="#">IT Managment</Link>
                    </li>
                    <li>
                      <Link href="#">Outsourcing</Link>
                    </li>
                    <li>
                      <Link href="#">Networking</Link>
                    </li>
                  </ul>
                </div>
              </div>
              {/* <!-- Footer Widget End --> */}
            </div>
            <div className="col-lg-3 col-sm-6">
              {/* <!-- Footer Widget Start --> */}
              <div className="footer-widget">
                <h4 className="footer-widget-title">Contact Information</h4>

                <div className="widget-info">
                  <ul>
                    <li>
                      <div className="info-icon">
                        <i className="flaticon-phone-call"></i>
                      </div>
                      <div className="info-text">
                        <span>
                          <Link href="#">+91 980 545 9192</Link>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div className="info-icon">
                        <i className="far fa-envelope-open"></i>
                      </div>
                      <div className="info-text">
                        <span>
                          <Link href="#">support@aclissglobal.com</Link>
                        </span>
                      </div>
                    </li>
                    <li>
                      <div className="info-icon">
                        <i className="flaticon-pin"></i>
                      </div>
                      <div className="info-text">
                        <span>Phase 7 Ind Area, Mohali 160059</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              {/* <!-- Footer Widget End --> */}
            </div>
          </div>
        </div>
        {/* <!-- Footer Widget Wrap End --> */}
      </div>

      {/* <!-- Footer Copyright Start --> */}
      <div className="footer-copyright-area">
        <div className="container">
          <div className="footer-copyright-wrap">
            <div className="row align-items-center">
              <div className="col-lg-12">
                {/* <!-- Footer Copyright Text Start --> */}
                <div className="copyright-text text-center">
                  <p>© Copyrights 2025 AclissGlobal All rights reserved. </p>
                </div>
                {/* <!-- Footer Copyright Text End --> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Footer Copyright End --> */}
    </div>
  );
}



export default Footer;